<template>
    <div class="index-container" :class="{ 'sidebar-open': sidebar }">
        <top-section>
            Prodotti non sincronizzati
            <template v-slot:buttons>
                <b-button v-if="checkedRows.length" @click="forceSync" label="Forza Sincronizzazione" />
            </template>
        </top-section>

        <product-table-section :data="products" :columns="columns" model="product" :tableShouldLoad="tableShouldLoad"
            pagination-route="product.index" :use-named-route="true" searchable checkable
            :checked-rows.sync="checkedRows" @handleProductSearch="handleProductSearch" />

        <portal to="sidebar">
            <section class="inner-content product-search">
                <b-tabs type="is-boxed">
                    <b-tab-item :label="__('strings.product.filters')">
                        <product-side-search :brands="filters.brands" :seasons="filters.seasons"
                            :categories="filters.categories" :genders="filters.genders" :retailers="filters.retailers"
                            :stocks="filters.stocks" :filters="inputs" @handleProductSearch="handleProductSearch" />
                    </b-tab-item>
                    <b-tab-item :label="__('strings.product.search_by_sku')">
                        <product-search-by-sku :filters="inputs" @handleProductSearch="handleProductSearch">
                        </product-search-by-sku>
                    </b-tab-item>
                </b-tabs>
            </section>
        </portal>
        <b-modal v-model="showDialog" has-modal-card trap-focus aria-role="dialog" aria-modal>
            <div class="loading-dialog">

                <div v-if="isWorking" class="wrap-loading"><div class="cd-loading"></div></div>
                <div class="product-info" v-if="isWorking">
                    <p>Elaborazione {{ checkedRows[indexTask].sku }}</p>
                </div>
                <div class="finish" v-if="!isWorking">
                    La richiesta di esportazione dei prodotti selezionati è stata completata. <br/><br/>
                    <b-button @click="closeDialog" label="Chiudi" />
                </div>
            </div>
        </b-modal>
    </div>


</template>


<script>
import ProductTableSection from "./table/ProductTableSection";

const filterMap = {};

export default {
    components: { ProductTableSection },
    data() {
        return {
            showDialog: false,
            isWorking: false,
            indexTask: 0,
            checkedRows: [],
            columns: [
                { "field": "thumbnail", "label": "Thumbnail", "width": 100 },
                { "field": "season_name", "label": "Season" },
                { "field": "name", "label": "Name" },
                { "field": "brand_name", "label": "Brand" },
                { "field": "sku", "label": "Sku" },
                { "field": "code", "label": "Code", "width": 200 },
                { "field": "quantity", "label": "Qty", "width": 100 },
                { "field": "retailers_list", "label": "Retailers" },
                { "field": "actions", "label": "Actions", "actions": ["edit"] }
            ],
            products: [],
            sidebar: false,
            tableShouldLoad: true,
            filtersLoaded: false,
            filters: {
                brands: {
                    toRetrieve: true,
                    model: 'brand',
                    input: 'brand_id'
                },
                genders: {
                    toRetrieve: true,
                    model: 'gender',
                    input: 'gender_id'
                },
                seasons: {
                    toRetrieve: true,
                    model: 'season',
                    input: 'season_id'
                },
                categories: {
                    toRetrieve: true,
                    model: 'category',
                    input: 'category_id'
                },
                retailers: {
                    data: [
                        {
                            id: 1,
                            name: "SamGP+FL",
                        },
                        {
                            id: 2,
                            name: "SamGG",
                        }]
                },
                stocks: {
                    data: [
                        {
                            id: 0,
                            name: "Out of Stock",
                        },
                        {
                            id: 1,
                            name: "In Stock",
                        }]
                },
            },
            inputs: {
                retailers: [],
                in_stock: [],
                brand_id: [],
                gender_id: [],
                category_id: [],
                parent_category_id: undefined,
                sub_category_id: undefined,
                season_id: [],
                sku: [],
                //page: undefined,
            },
            filteredProductIds: null,
            onHistoryPopstateCb: this.onHistoryPopstate.bind(this)
        }
    },
    beforeMount() {
        for (let [filterKey, filterProp] of Object.entries(this.filters)) {
            if (filterProp.toRetrieve) {
                this.filters[filterKey] = {
                    ...filterProp,
                    data: [],
                    loading: true,
                    error: null,
                    input: ''
                };
                this.fetchFilters(filterKey, filterProp);
            }
        }
        this.filtersLoaded = true;
        let searchParams = new URLSearchParams(window.location.search);
        let query = {};
        for (let [key, value] of searchParams.entries()) {
            query[key] = searchParams.get(key).split(",").map((el) => eval(el));
        }
        this.assignData(query);
        // Set the current page from query string
        this.inputs.page = searchParams.get("page") ? eval(searchParams.get("page")) : 1;
    },
    mounted() {
        this.handleProductSearch();
    },
    methods: {
        /**
         * This method is used to retrieve programmatically the data for filters
         */
        fetchFilters(filterKey, filterProp) {
            this.filters[filterKey].loading = true;

            // Set the endpoint to fetch
            let endpoint = filterProp.model;
            endpoint += (filterProp.hasOwnProperty('filters') || this.filteredProductIds) ? '/filter' : '/index';

            // Fetch the filter
            axios.get(endpoint)
                .then(response => {
                    this.filters[filterKey].data = response.data;
                    filterMap[filterKey] = {};
                    console.log(filterKey);
                    response.data.forEach((s) => { filterMap[filterKey][s.id] = s.name; });

                })
                .catch(error => {
                    this.filters[filterKey].error = error.response.data.message;
                })
                .finally(() => {
                    this.filters[filterKey].loading = false
                })
        },
        selectOptions(option, field) {
            this.inputs[field] = option ? option.id : null;
            this.filterProducts();
        },
        /**
         * This method is used to retrieve filtered data
         */
        handleProductSearch(filters) {
            this.inputs = { ...this.inputs, ...filters };

            let searchParams = new URLSearchParams(window.location.search);
            let query = {};
            let queryString = {};
            for (let [key, value] of Object.entries(this.inputs)) {
                if (value === undefined || value.length === 0) continue;
                query[key] = value;
                searchParams.set(key, value);
                queryString[key] = Array.isArray(value) ? value.join(",") : value;
            }

            //this.$router.replace({ query: queryString });

            // Replace the old query string
            this.tableShouldLoad = true;
            axios.get('/product/not-sync', { params: searchParams })
                .then(response => {
                    this.products = response.data.products;
                    this.filteredProductIds = response.data.product_ids;
                    this.addAttributeName();
                })
                .finally(() => {
                    this.tableShouldLoad = false;
                    window.scrollTo({ top: 0, behavior: 'smooth' })
                });
        },
        assignData(data) {
            for (let key of Object.keys(this.inputs)) {
                if (data.hasOwnProperty(key)) {
                    this.inputs[key] = data[key];
                }
            }
        },
        onHistoryPopstate(event) {
            if (event.state) {
                this.assignData(event.state);
            }
        },
        forceSync() {
            this.showDialog = true;
            this.isWorking = true;
            this.indexTask = 0;
            this.exportNextProduct();
        },

        exportNextProduct() {
            if(this.indexTask>=this.checkedRows.length){
                this.isWorking = false;
                return;
            }
            const next = () => {
                this.indexTask++;
                this.exportNextProduct();
            }
            axios.post(`/export/product`, { productId:this.checkedRows[this.indexTask].id })
                .then(_ => {
                    next();
                })
                .catch(_ => {
                    next();
                    this.toaster("There was an error with your request", "is-danger")
                });
        },

        closeDialog(){
            this.showDialog = false;
             this.filterProducts();
        },

        addAttributeName() {
            this.products.data = this.products.data.map((p) => {
                const listIdRet = p.retailers.split(",");
                return {
                    ...p,
                    removed_on: null,
                    brand_name: filterMap['brands'][p.brand_id],
                    season_name: filterMap['seasons'][p.season_id],
                    retailers_list: listIdRet.map((e) => {
                        return (e == "1" ? "SamGP+F" : "SamGG")
                    }).join(", ")
                }
            })
        }
    },
}
</script>
<style>
.loading-dialog {
    background-color: #fff;
    padding: 40px;
    position: relative;
    min-width: 200px;
}
.wrap-loading{
    text-align: center;
    padding-bottom: 20px;
}
</style>